/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabet,
    SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabetFromJSON,
    SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabetFromJSONTyped,
    SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabetToJSON,
    SharedserviceMelcoModelsAlphabetListItem,
    SharedserviceMelcoModelsAlphabetListItemFromJSON,
    SharedserviceMelcoModelsAlphabetListItemFromJSONTyped,
    SharedserviceMelcoModelsAlphabetListItemToJSON,
    SharedserviceMelcoModelsCustomWarning,
    SharedserviceMelcoModelsCustomWarningFromJSON,
    SharedserviceMelcoModelsCustomWarningFromJSONTyped,
    SharedserviceMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsAlphabetCollection
 */
export interface SharedserviceMelcoModelsAlphabetCollection {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsAlphabetCollection
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsAlphabetCollection
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsAlphabetCollection
     */
    alphabet_count?: number;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsCustomWarning>}
     * @memberof SharedserviceMelcoModelsAlphabetCollection
     */
    warning_list?: Array<SharedserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsAlphabetListItem>}
     * @memberof SharedserviceMelcoModelsAlphabetCollection
     */
    alphabet_list?: Array<SharedserviceMelcoModelsAlphabetListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsAlphabetCollection
     */
    publish_state?: number;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoModelsAlphabetCollection
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoModelsAlphabetCollection
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoModelsAlphabetCollection
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabet}
     * @memberof SharedserviceMelcoModelsAlphabetCollection
     */
    default_alphabet?: SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabet;
}

export function SharedserviceMelcoModelsAlphabetCollectionFromJSON(json: any): SharedserviceMelcoModelsAlphabetCollection {
    return SharedserviceMelcoModelsAlphabetCollectionFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsAlphabetCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsAlphabetCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'alphabet_count': !exists(json, 'alphabet_count') ? undefined : json['alphabet_count'],
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(SharedserviceMelcoModelsCustomWarningFromJSON)),
        'alphabet_list': !exists(json, 'alphabet_list') ? undefined : (json['alphabet_list'] === null ? null : (json['alphabet_list'] as Array<any>).map(SharedserviceMelcoModelsAlphabetListItemFromJSON)),
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'default_alphabet': !exists(json, 'default_alphabet') ? undefined : SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabetFromJSON(json['default_alphabet']),
    };
}

export function SharedserviceMelcoModelsAlphabetCollectionToJSON(value?: SharedserviceMelcoModelsAlphabetCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'alphabet_count': value.alphabet_count,
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(SharedserviceMelcoModelsCustomWarningToJSON)),
        'alphabet_list': value.alphabet_list === undefined ? undefined : (value.alphabet_list === null ? null : (value.alphabet_list as Array<any>).map(SharedserviceMelcoModelsAlphabetListItemToJSON)),
        'publish_state': value.publish_state,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'default_alphabet': SharedserviceMelcoModelsAlphabetCollectionDefaultAlphabetToJSON(value.default_alphabet),
    };
}


